import FEATURE_FLAGS from "@flags";

const baseTabs = [
  {
    key: "periods",
    label: "Periods",
  },
  {
    key: "projects",
    label: "Projects",
  },
  {
    key: "ledger",
    label: "Ledger",
  },
  {
    key: "distributions",
    label: "Distributions",
  },
];

const commonTabs = FEATURE_FLAGS.includes("rankBreakdown")
  ? [...baseTabs, { key: "rank-breakdown", label: "Rank Breakdown" }]
  : baseTabs;

const adminTabs = [];

export { commonTabs, adminTabs };

export default [...commonTabs, ...adminTabs];
